import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {StoryFragment} from "./fragments/Story";

export const GET_HOME_CONTENT = gql`
  query GetHomeContent {
    homeContent {
      helpfulLinks {
        heading
        link
        typeName
        position
        linkTargetType
      }
      featuredCompanies {
        companyProfilePicture {
          ...imageFields
        }
      }
      featuredStories {
        ...storyFields
      }
    }
  }
  ${StoryFragment}
  ${ImageFragment}
`;
